import {applySpec, flow, tag2url} from '@yandex-delivery/utils'

import {Vertical, Verticals} from '../../../model/order/types'
import {verticalGetter} from '../../../repo/dcaa/getters/vertical'
import {FormOrderResponse} from '../../../repo/dcaa/types'

const toVertical = applySpec({
  id: verticalGetter('id'),
  title: verticalGetter('title'),
  imgSrc: flow(verticalGetter('image_tag'), tag2url),
  description: verticalGetter('subtitle'),
})

export function toVerticals(response: FormOrderResponse): Verticals {
  const initialValue: Verticals = {
    groups: [],
    verticals: {},
  }
  const allVerticals = response.verticals.map(toVertical)

  return response.vertical_groups.reduce((acc, group) => {
    const groupVerticals = (group.verticals || []).sort()
    const {id, verticals} = allVerticals.reduce<{id: string; verticals: Vertical[]}>(
      (acc, vertical) => {
        if (groupVerticals.includes(vertical.id)) {
          acc.id += '/' + vertical.id
          acc.verticals.push(vertical)
        }

        return acc
      },
      {id: '/', verticals: []},
    )

    acc.groups.push({
      label: group.title,
      value: id,
    })
    acc.verticals[id] = verticals

    return acc
  }, initialValue)
}
